export default "__VITE_ASSET__BvqmESsl__"